import { connect } from 'react-redux'
import ClientPortal from '../components/client-portal'

const mapStateToProps = state => ({
  ...state.clientPortal
})

const mapDispatchToProps = dispatch => ({
  onPageChange: payload => dispatch({type: 'CLIENT_PORTAL.PAGE_CHANGE', payload}),
  updateCompanies: payload => dispatch({type: 'CLIENT_PORTAL.UPDATE_COMPANIES', payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientPortal)
